module.exports = __webpack_public_path__ + "static/media/highscore.d42e0ec2.png";